export const config = {
    showGallery: false,
};
